import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import HomeRepairServiceOutlinedIcon from '@mui/icons-material/HomeRepairServiceOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';

export const navLinks = [
  { label: 'Product', href: '/#product' },
  { label: 'Features', href: '/#features' },
  { label: 'Why Choose Us', href: '/#why-choose-us' },
  { label: 'FAQ', href: '/#faq' },
];

export const featureHighlights = [
  {
    title: 'Smart Service History Tracking',
    description:
      "Snap a photo of the bill and it's logged automatically — no more vague memory, just an exact record of every service, repair and renewal.",
    color: '#EF4444',
    Icon: HistoryOutlinedIcon,
  },
  {
    title: 'Intelligent Service Reminders',
    description: "Walk in prepared, not caught off guard — get notified before a bill is due or a service is overdue.",
    color: '#2563EB',
    Icon: NotificationsActiveOutlinedIcon,
  },
  {
    title: 'Free & Cloud-Based Storage',
    description:
      'Every bill in one place instead of scattered across old photos and paper — access your records anytime, from any device.',
    color: '#8B5CF6',
    Icon: CloudDoneOutlinedIcon,
  },
  {
    title: 'Cost Monitoring & Smart Savings',
    description: "Know the cost before you're quoted one. Spot spending trends early and stop overpaying.",
    color: '#F59E0B',
    Icon: TrendingUpOutlinedIcon,
  },
];

export const serviceCategories = [
  {
    title: 'Vehicles & Transportation',
    color: '#EF4444',
    Icon: DirectionsCarFilledOutlinedIcon,
    bullets: ['Track service history', 'Get maintenance reminders'],
  },
  {
    title: 'Home Maintenance',
    color: '#2563EB',
    Icon: HomeRepairServiceOutlinedIcon,
    bullets: ['Record appliance servicing', 'Monitor repair costs'],
  },
  {
    title: 'Healthcare Equipment',
    color: '#8B5CF6',
    Icon: MedicalServicesOutlinedIcon,
    bullets: ['Maintain service logs', 'Track inspections'],
  },
  {
    title: 'Workshops & Garages',
    color: '#F59E0B',
    Icon: HandymanOutlinedIcon,
    bullets: ['Manage customer records', 'Track repairs & parts'],
  },
];

export const whyChooseUsPoints = [
  { label: 'All-in-One Maintenance Hub', color: '#EF4444' },
  { label: 'Organised & Category-Based Tracking', color: '#2563EB' },
  { label: 'Access Anytime, Anywhere', color: '#F59E0B' },
  { label: 'Confidence Instead of Guesswork', color: '#8B5CF6' },
  { label: 'A Timeline You Can Always Point To', color: '#EF4444' },
];

export const testimonials = [
  {
    name: 'Michelle Rivera',
    role: 'Operations Lead, FinCalculator',
    initials: 'MR',
    quote:
      "Simple, powerful and incredibly easy to use. Our team adapted within days and we've never tracked service history this smoothly.",
  },
  {
    name: 'Arjun Mehta',
    role: 'Founder, Morwills',
    initials: 'AM',
    quote:
      'The reminders alone have saved us from missing renewals more times than I can count. Genuinely essential now.',
  },
  {
    name: 'Sara Ahmed',
    role: 'Facilities Manager, Vivon Global',
    initials: 'SA',
    quote:
      'We manage dozens of assets across sites and Remembr keeps every record organised in one dashboard.',
  },
];

export const faqs = [
  {
    question: 'What is Remembr?',
    answer:
      'Remembr is a cloud-based platform that helps you log, monitor and get reminders for every recurring bill or service, from vehicles to home appliances.',
  },
  {
    question: 'Is Remembr really free?',
    answer:
      'Yes. The core tracking and reminder features are free to use, with optional premium plans for advanced reporting.',
  },
  {
    question: 'Can I track multiple categories at once?',
    answer:
      'Absolutely. Group diaries by vehicles, electronics, home maintenance and more, all from a single dashboard.',
  },
  {
    question: 'Is my data secure?',
    answer:
      "Your data is encrypted and never sold. You're always in control of what you track and who can see it.",
  },
];

export const footerColumns = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '/#features' },
      { label: 'Why Choose Us', href: '/#why-choose-us' },
      { label: 'Testimonials', href: '/#testimonials' },
      { label: 'FAQs', href: '/#faq' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Help Center', href: '/contact' },
      { label: 'Contact Us', href: '/contact' },
    ],
  },
];

export const socialLinks = [
  { label: 'Facebook', href: 'https://www.facebook.com/arrayscript' },
  { label: 'X', href: 'https://x.com/arrayscript' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/arrayscript' },
  { label: 'Instagram', href: 'https://www.instagram.com/array.script' },
];
